import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	delete: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	delete: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.delete-project-menu-item.delete',
		defaultMessage: 'Move to trash',
		description: 'Dropdown menu item. Opens delete project modal',
	},
});
export default messages;
